import React from 'react';
import {
  Paper, IconButton, List, ListItem, ListItemText
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../context/AuthContext';

function MarcaList({ marcas, onEdit, onDelete }) {
  const { user } = useAuth();
  const canEditDelete = user && (user.tipo_usuario === 'admin' || user.tipo_usuario === 'sindico');

  return (
    <Paper sx={{ maxHeight: 300, overflow: 'auto', mt: 2 }}>
      <List dense>
        {marcas.map((marca) => (
          <ListItem
            key={marca.id}
            secondaryAction={
              canEditDelete && (
                <>
                  <IconButton edge="end" aria-label="edit" onClick={() => onEdit(marca)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton edge="end" aria-label="delete" onClick={() => onDelete(marca.id)}>
                    <DeleteIcon />
                  </IconButton>
                </>
              )
            }
          >
            <ListItemText primary={marca.nome} secondary={`ID: ${marca.id}`} />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
}

export default MarcaList;
